export * from "./src/map-object-thumbnails";
